import * as mTypes from '../mutation-types'

const state = {
  back: false
}

const actions = {

}

const mutations = {
  [mTypes.TRANSITION_SET_BACK] (state, back = false) {
    state.back = back
  }
}

const getters = {
  transitionName (state) {
    if (state.back) {
      return 'lxm-transition-back'
    } else {
      return 'lxm-transition'
    }
  },
  pageTransitionName (state) {
    if (state.back) {
      return 'lxm-page-transition-back'
    } else {
      return 'lxm-page-transition'
    }
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/transition.js